import { Skeleton } from '@/_components';

export function Loading() {
  return (
    <div className="flex flex-col">
      {Array.from({ length: 10 }).map((_, index) => (
        <div key={index} className="border-c-border-muted flex items-center gap-3 border-b py-3">
          {/* Ranking Number */}
          <Skeleton className="h-4 w-6 rounded-md" />

          {/* Competitor Avatar */}
          <Skeleton className="h-7 w-9 shrink-0 rounded-md" />

          <div className="flex w-full flex-col gap-2">
            <div className="flex w-full items-center justify-between gap-2">
              <div className="min-w-0 flex-1">
                {/* Competitor Name */}
                <Skeleton className="h-4 w-1/2" />
              </div>

              {/* Companies Count */}
              <Skeleton className="h-3 w-1/4" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
